import { Banner } from "./Banner";
import { LandingPage } from "./LandingPage";

export const BrandedApp = {
  Banner,
  LandingPage,
};
